import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Navigate, useLocation, useParams } from "react-router"
import { setRoleData } from "../../Module/Shared/SharedSlices/RolesSlice"
import { StorageKey } from "../enums"
import SessionService from "../SessionService"
import { RootState } from "../store"
import { PrivateRouteProps } from "./RoutingType"
import { Role } from "../../Types/RoleType"

const handleRoleNavigation = (Role: Role, currentRole: Role) => async (dispatch: Function) => {
    if (currentRole !== Role) {
        SessionService.setItem(StorageKey.roles, Role!)
        dispatch(setRoleData(Role!))
    }
}

const PrivateRoute = ({ Component, Role }: PrivateRouteProps) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const isAuthenticated = useSelector((state: RootState) => state.signinSlice.authenticationSlice)
    const currentRole = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const { id, eventId } = useParams()
    const roleStatus = useSelector((state: RootState) => state.rolesSlice.RoleStatusSlice.status)
    const organization = useSelector((state: RootState) => state.organizationsSlice.organizationSlice.organization)

    useEffect(() => {
        if (!roleStatus) {
            dispatch<any>(handleRoleNavigation(Role, currentRole))
        }
    }, [Role, currentRole, dispatch, eventId, id, organization.id])

    const authenticated = isAuthenticated.hasAccessToken

    const roomPreviewPath = (() => {
        const roomPathMatch = location.pathname.match(/^\/room\/(\d+)$/)
        if (roomPathMatch) {
            return `/room-preview/${roomPathMatch[1]}${location.search}`
        }

        const organizationRoomPathMatch = location.pathname.match(/^\/room\/\d+\/(\d+)$/)
        if (organizationRoomPathMatch) {
            return `/room-preview/${organizationRoomPathMatch[1]}${location.search}`
        }

        const roomPostPathMatch = location.pathname.match(/^\/room-post\/(\d+)\/\d+$/)
        if (roomPostPathMatch) {
            return `/room-preview/${roomPostPathMatch[1]}`
        }

        const organizationRoomPostPathMatch = location.pathname.match(/^\/room-post\/\d+\/(\d+)\/\d+$/)
        if (organizationRoomPostPathMatch) {
            return `/room-preview/${organizationRoomPostPathMatch[1]}`
        }

        return null
    })()

    if (authenticated) {
        return <Component />
    }

    if (roomPreviewPath) {
        return <Navigate to={roomPreviewPath} />
    }

    return <Navigate to={`${`/signin?redirectUrl=${location.pathname}${location.search}`}`} />
}
export default PrivateRoute
